module.exports = __webpack_public_path__ + "static/media/veona-signature-package.ba17aa64.png";